function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var defaultOptions = {
    keepEmptyValues: true,
    shouldUseInitialDelimiter: true
};
export function appendQueryParams(url, queryParams, userOptions) {
    var options = Object.assign({}, defaultOptions, userOptions);
    var delimiter;
    if (!options.shouldUseInitialDelimiter) {
        delimiter = '';
    } else if (url && url.slice(-1) === '?') {
        delimiter = '';
    } else if (url && url.indexOf('?') === -1) {
        delimiter = '?';
    } else {
        delimiter = '&';
    }
    var queryString = Object.entries(queryParams).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (value === null || value === undefined || !options.keepEmptyValues && value === '') {
            return acc;
        }
        var processedValue = options.shouldNotEncodeURI ? value : encodeURIComponent(value);
        if (acc) {
            return "".concat(acc, "&").concat(key, "=").concat(processedValue);
        } else {
            return "".concat(delimiter).concat(key, "=").concat(processedValue);
        }
    }, '');
    return "".concat(url).concat(queryString);
}
export function getOriginFromUrl(url) {
    var origin = new URL(url).origin;
    return origin === 'null' ? null : origin;
}
export function getProtocol(url) {
    return new URL(url).protocol;
}
export function replaceUrlProtocol(originalUrl, newProtocol) {
    var url = new URL(originalUrl);
    url.protocol = newProtocol;
    return url.toString();
}

//# sourceMappingURL=url-builder.js.map